// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"landing-button_buttonContainer__85JvH","button":"landing-button_button__1BUfH"};